import { Problem } from '@yandex-int/k-common/typings';

export interface ProblemPreviewBg {
    bgColor: string | undefined;
    bgCover: string | undefined;
}

export interface ProblemPreviewIllustration {
    illustration?: string | undefined;
}

export const getProblemPreviewBg = (problem: Problem): ProblemPreviewBg => {
    return {
        bgColor: problem.background_color,
        bgCover: problem.background_cover,
    };
};
export const getProblemPreviewIllustration = (problem: Problem): ProblemPreviewIllustration => {
    return {
        illustration: problem.background_illustration,
    };
};
